<template>
	<page enable-flex>
		<view-list ref="view" work-type="10" :search="{scan: true}">
			<template #link>
				<topbar-link v-if="auth('b_app_product_view')" count="0" @click="mp.navigateWeb('/sales/product/abnormal')">下架异常</topbar-link>
			</template>

			<template #filter>
				<m-search>
					<m-search-item label="等级">
						<c-radio-group name="level_type" :options="LEVEL_TYPE"></c-radio-group>
					</m-search-item>
					<m-search-item label="是否质检">
						<c-radio-group name="is_quality_check" :options="qualityCheckOptions"></c-radio-group>
					</m-search-item>
				</m-search>
			</template>

			<template #handle>
				<topbar-handle type="model" label="机型" name="model_id"></topbar-handle>
				<topbar-handle type="option" label="渠道" name="channel_id" options="CHANNEL"></topbar-handle>
			</template>

			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #tag>
						<c-state dict="LEVEL_TYPE" :value="data.level_type" type="hollow"></c-state>
					</template>

					<template #name>
						{{[data.brand_name, data.model_name, data.color_name, data.memory_name].filter(item => item).join(' ')}}
					</template>

					<template #state>
						<c-state v-if="sourceHandoverStateText(data)" :color="isSourceRejectPending(data) ? '#e53e3e' : '#666666'" type="state">{{sourceHandoverStateText(data)}}</c-state>
						<!--看销售进度还是看条码状态由服务端按版本能力下发（与PC端同一口径）：门店版条码全程停在在库(10)，销售进度才是店员关心的-->
						<c-state v-else-if="data.show_sale_state" dict="saleOverallStateDic" :value="data.overall_state" type="state"></c-state>
						<c-state v-else dict="productStateDic" :value="data.state"></c-state>
					</template>

					<template #area>
						<c-field label="背贴码">{{data.produce_unique_code}}</c-field>
						<c-field label="IMEI">{{data.produce_imei}}</c-field>
						<c-field label="采购价">
							<span>￥{{data.purchase_price}}</span>
							<label>维修价：</label>
							<span>￥{{data.repair_cost}}</span>
						</c-field>
						<c-field v-if="data.channel_list && data.channel_list.length" label="推送">
							<div class="flex-wrap" style="column-gap: .22rem">
								<template v-for="(item, i) in data.channel_list">
									<span :key="i" style="white-space: nowrap;">{{item.channel_name}}：<span style="color: #FF6900;">￥{{item.sale_price}}</span></span>
								</template>
							</div>
						</c-field>
					</template>

					<template #operate>
						<c-button v-if="data.buttons?.confirm_reject?.visible && auth('b_app_product_confirm_reject')" color="main" hollow @click="confirmReject(data)">同意驳回</c-button>
						<!--行级按钮可见性由服务端按版本能力+商品/条码/渠道状态计算下发（data.buttons），端内不再写 hasHandover/state==32/overall_state/isOnSale 硬编-->
						<c-button v-if="data.channel_list && data.channel_list.length && auth('b_app_product_channel')" hollow @click="$refs.channel.open(data.channel_list)">推送渠道</c-button>
						<c-button v-if="data.buttons?.view_quality_report?.visible && auth('b_app_product_quality_report')" hollow @click="mp.navigateWeb('/sales/product/report', {code: data.produce_unique_code})">质检报告</c-button>
						<!--质检 / 维修 / 送修 在各自的列表页作业（H5 质检列表 quality/manage.vue、维修列表 repair/manage.vue），商品列表不挂这些入口 -->
						<c-button v-if="data.buttons?.transfer?.visible && auth('b_app_product_transfer')" @click="mp.navigateWeb('/stock/allot', {code: data.produce_unique_code, from: 3})">调拨</c-button>
						<!--返库是把商品从销售区退回库存区，无接驳的版本不分区，服务端已按版本能力直接判定 return_to_stock 不可见-->
						<c-button v-if="data.buttons?.return_to_stock?.visible && auth('b_app_product_return')" @click="returnToStock([data])">返库</c-button>
						<c-button v-if="data.buttons?.shelf?.visible && auth('b_app_product_shelf')" color="main" hollow @click="checkDepositBefore(() => $refs.onlist.open(data))">上架</c-button>
						<c-button v-if="data.buttons?.offshelf?.visible && auth('b_app_product_offshelf')" color="red" hollow @click="$refs.delist.open(data)">下架</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>

		<channel ref="channel"></channel>
		<onlist ref="onlist" @resolve="$refs.view.update()"></onlist>
		<delist ref="delist" @resolve="$refs.view.update()"></delist>
	</page>
</template>

<script>
	import saasDeposit from '@/mixins/saas_deposit';
	import handoverReject from '@/mixins/handover_reject'
	import channel from './product_channel.vue'
	import onlist from './product_onlist.vue'
	import delist from './product_delist.vue'
	import {mapGetters} from 'vuex'
	import {asyncMapState} from '@/store'

	export default {
		mixins: [saasDeposit, handoverReject],
		handoverModuleType: 3,
		components: {
			channel,
			onlist,
			delist
		},

		data() {
			return {
				qualityCheckOptions: [{
					name: '是',
					value: 1
				}, {
					name: '否',
					value: 2
				}]
			}
		},

		computed: {
			...mapGetters(['hasHandover']),
			...asyncMapState(['LEVEL_TYPE'])
		},
		
		methods: {
			returnToStock(list) {
				this.$confirm({
					message: '返库后所有渠道将下架，确认要将该商品返库吗？',
					resolve: () => {
						this.request({
							url: '/sale/product/batchReturnStock',
							data: {
								product_ids: list.map(item => item.id)
							},
							loading: true,
							success: () => {
								this.$message({
									message: '操作成功'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>